/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Paragraph/theme';

export const ParagraphTheme = theme;
